export default __webpack_public_path__ + "static/media/blog_single.1f989c91.png";